import { createFileRoute } from '@tanstack/react-router';
import { BillingIndexPage } from '@/components/BillingIndexPage';

export const Route = createFileRoute('/_authenticated/billing/')({
  component: BillingIndexPage,
});
